import toast from '@/components/toastPlugin'
import store from '@/store'
const successRspMessage = function (message, title) {
  let time = 5000
  if (!message) {
    message = 'Успешно'
  }
  if (!title) {
    title = ''
  }
  toast.message.success(message, title, time)
}

const errorRspMessage = function (message, title) {
  let time = 5000
  if (!message) {
    message = 'Ошибка при выполнении'
  }
  if (!title) {
    title = 'Ошибка'
  }
  toast.message.error(message, title, time)
}

const errorResponse = function (error) {
  let time = 5000
  if (error.response.status >= 500 && error.response.status < 600) {
    errorRspMessage('Сервер вернул ' + error.response.status + ' код ', 'Ошибка сервера', time)
  }
  if (error.response.status === 403) {
    errorRspMessage('Данная операция запрещена')
  }
  if (error.response.status === 422 && error.response.data.errors) {
    let str = ''
    for (let i in error.response.data.errors) {
      str = str + error.response.data.errors[i]
    }
    errorRspMessage(str)
  } else if (error.response.data.message) {
    errorRspMessage(error.response.data.message)
  }
  store.commit('ERROR_HTTP', error.response.status)
}
const succcesResponse = function (response) {
  return response.data
}
export default {
  successRspMessage,
  errorRspMessage,
  errorResponse,
  succcesResponse
}



// WEBPACK FOOTER //
// ./src/api/responses.js